import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "sort_code_format",
	standalone: false
})
export class SortCodeFormatPipe implements PipeTransform {
	transform(value: string): string {
		return value.match(new RegExp(".{1,2}", "g")).join("-");
	}
}
